export default "__VITE_ASSET__d1be5c16__"